import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Redirect, Route } from "react-router-dom";

export const AdminRoute = (props) => {
    const { component: Component, ...rest } = props;
    const { context, isVendexSuperUser } = useContext(AuthContext);

    return (
        <Route
            {...rest}
            render={(props) =>
                isVendexSuperUser(context.user) ? (
                    <Component {...props} {...rest} />
                ) : (
                    <Redirect
                        to={{
                            pathname: "/home",
                            state: { from: props.location },
                        }}
                    />
                )
            }
        />
    );
};
